import { post } from '@/utils/request'

export default {
    add: query => post('/rrbi/shareRevenue/addShareRevenue',query),
}